<div *ngIf="selectedFeature?.layer?.source" class="train-hover column-wrapper">

  <div class="row-wrapper">

    <div class="column-wrapper">
      <div *ngIf="selectedFeature.properties.calculatedDelta !== undefined" class="attention-box" [style.backgroundColor]="deltaColor">
        <div class="attention-value">
          {{selectedFeature.properties.calculatedDelta}}
        </div>
        <div class="attention-heading">
          {{'Delta' | translate}}
        </div>
      </div>

      <div class="attention-box" [style.backgroundColor]="'#466273'">
        <div class="attention-value">
          {{selectedFeature.properties.velocity}}
        </div>
        <div class="attention-heading">
          {{'Velocity' | translate}}
        </div>
      </div>
    </div>

    <div class="column-wrapper details">
      <span>{{'Location updated' | translate}}: {{selectedFeature.properties.createdAt | qmDateDistance}}</span>
      <span>{{'Equipment number' | translate}}: {{selectedFeature.properties.equipment}}</span>
      <span><qm-vrgroup-train-compositions [train]="selectedFeature.properties"></qm-vrgroup-train-compositions></span>

      <span *ngIf="selectedFeature?.properties?.radioControlled === true">
        {{'Radio controlled' | translate}}: {{'Yes' | translate}}
      </span>
      <span *ngIf="selectedFeature?.properties?.radioControlled === false">
        {{'Radio controlled' | translate}}: {{'No' | translate}}
      </span>

      <span>{{'Details' | translate }}:</span>
      <div class="link-list" *qmAuth="'objectdescription-read'">
        <div *ngIf="selectedFeature?.properties">
          <qm-element-text [selectedFeature]="selectedFeature"></qm-element-text>
        </div>
      </div>

    </div>

  </div>
  <qm-train-personnel [feature]="selectedFeature"></qm-train-personnel>
</div>
